import { FormattedMessage, useIntl } from 'react-intl';
import classNames from 'classnames';
import type { ChangeEvent } from 'react';

export interface FormInputFieldProps {
    translationId: string;
    value?: string;
    maxLength?: number;
    propertyName?: string;
    formError?: string | undefined;
    hasError?: boolean;
    disabled?: boolean;
    autoFocus?: boolean;
    required?: boolean;
    dataAttribute?: string;
    onValueChange?: (propertyName: string, changedValue: string) => void;
}

export const FormInputField = (props: FormInputFieldProps) => {
    const {
        translationId,
        value,
        maxLength,
        propertyName,
        formError,
        disabled,
        autoFocus,
        required,
        dataAttribute,
        onValueChange,
    } = props;

    const intl = useIntl();

    const onChange = (event: ChangeEvent<HTMLInputElement>) => {
        return onValueChange && propertyName ? onValueChange(propertyName, event.target.value) : () => {};
    };

    return (
        <div className={classNames('form-group', formError && 'has-feedback has-error')}>
            <label>
                <FormattedMessage id={translationId} /> {required && '*'}
            </label>
            <div className='input-group'>
                <input
                    className='form-control'
                    type='text'
                    readOnly={disabled ? disabled : false}
                    value={value ? value : ''}
                    placeholder={intl.formatMessage({ id: translationId })}
                    onChange={onChange}
                    maxLength={maxLength ? maxLength : -1}
                    data-cy={dataAttribute && dataAttribute}
                    // biome-ignore lint/a11y/noAutofocus: suppress out of convenience during migration to biome
                    autoFocus={autoFocus ? autoFocus : false}
                />
            </div>
            {formError && (
                <span className={'help-block'}>
                    <FormattedMessage id={formError} />
                </span>
            )}
        </div>
    );
};
